exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1WAl-o4W1dMDfWA6FgTjZJ {\n  background-color: #000;\n  color: #fff;\n}\n\n._2Mg0pOATQVp1xjkpz4yenF {\n  font-size: 18px;\n}\n", ""]);

// exports
exports.locals = {
	"baseStyle": "_1WAl-o4W1dMDfWA6FgTjZJ",
	"someStyle": "_2Mg0pOATQVp1xjkpz4yenF _1WAl-o4W1dMDfWA6FgTjZJ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./~/postcss-loader!./src/styles/electrify-react.css
// module id = 135
// module chunks = 0